var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTwitter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.914 25A12.099 12.099 0 0 1 2.401 6.9a12.097 12.097 0 0 1 12.944-5.844c.438.089.87.202 1.295.34a.407.407 0 0 1-.249.773 11.05 11.05 0 0 0-1.208-.316 11.283 11.283 0 1 0 7.687 5.743.406.406 0 1 1 .719-.382A12.1 12.1 0 0 1 12.914 25Z",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.108 4.977a.408.408 0 0 1-.29-.116 10.904 10.904 0 0 0-.91-.806 10.7 10.7 0 0 0-.756-.55.407.407 0 0 1-.115-.562.412.412 0 0 1 .565-.116c.29.185.55.385.81.58.342.271.668.561.977.869a.406.406 0 0 1-.29.695l.01.006ZM8.024 8l3.864 5.166L8 17.366h.875l3.404-3.677 2.75 3.678h2.979l-4.081-5.457L17.546 8h-.875l-3.135 3.387L11.002 8H8.024Zm1.287.645h1.368l6.042 8.077h-1.368L9.31 8.645Z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.1dc7a4fa6f2db6f0ac9862359972760e.svg";
export { ForwardRef as ReactComponent };